const handleFocusBackwards = (HTMLFocusableElements, currentActiveElementIndex) => {
    if (currentActiveElementIndex === 0) {
        return HTMLFocusableElements[HTMLFocusableElements.length - 1].focus();
    }
    return HTMLFocusableElements[currentActiveElementIndex - 1].focus();
};
export default handleFocusBackwards;
//# sourceMappingURL=handleFocusBackwards.js.map